import { ReactComponent as EmptyIcon } from '#/assets/icons/common/empty.svg';

export default function Empty() {
  return (
    <div className="flex items-center justify-center p-20">
      <EmptyIcon className="mx-auto" />
    </div>
  );
}
